import React, { useState } from "react";
import FullScreenModalConfigPosiciones from "./FullScreenConfig/FullScreenModalConfigPosiciones";
import FullScreenModalConfigAcumulado from "./FullScreenConfig/FullScreenModalConfigAcumulado";

const CardConfigClasificacionFaseFinal = () => {
  const [openPosiciones, setOpenPosiciones] = useState(false);
  const [openAcumulado, setOpenAcumulado] = useState(false);

  return (
    <>
      <div className="flex justify-center bg-gray-100 p-4">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-2xl w-full">
          <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">
            Configuración para la Clasificación Fase Final
          </h2>

          <div className="flex flex-col gap-3">
            <div className="flex justify-between">
              <label className="text-2xl block text-gray-700 mb-2">
                Configuración Posiciones
              </label>
              <div className="flex justify-center">
                <button
                  onClick={() => setOpenPosiciones(true)}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Configurar
                </button>
              </div>
            </div>

            <div className="flex justify-between">
              <label className="text-2xl block text-gray-700 mb-2">
                Configuración Acumulados
              </label>
              <div className="flex justify-center">
                <button
                  onClick={() => setOpenAcumulado(true)}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Configurar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openPosiciones ? (
        <FullScreenModalConfigPosiciones
          open={openPosiciones}
          setOpen={setOpenPosiciones}
        />
      ) : null}
      {openAcumulado ? (
        <FullScreenModalConfigAcumulado
          open={openAcumulado}
          setOpen={setOpenAcumulado}
        />
      ) : null}
    </>
  );
};

export default CardConfigClasificacionFaseFinal;
